import type { IConfig } from '@ohpen/react-utils';
import type { AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';

export function getOidcConfig(config: IConfig): AuthProviderProps {
  // Build scope string including custom scopes for the API
  const customScopes = config.AWS?.APP_CLIENT_CUSTOM_SCOPES || [];
  const baseScopes = 'openid profile email';
  const scope = customScopes.length > 0 ? `${baseScopes} ${customScopes.join(' ')}` : baseScopes;

  return {
    authority: `https://cognito-idp.${config.AWS.REGION}.amazonaws.com/${config.AWS.USER_POOL_ID}`,
    client_id: config.AWS.USER_POOL_APP_CLIENT_ID,
    redirect_uri: config.AWS.USER_POOL_REDIRECT_URL,
    post_logout_redirect_uri: config.AWS.USER_POOL_REDIRECT_URL,
    scope,
    automaticSilentRenew: true,
    // Use localStorage so tokens persist across tabs and direct URL navigation.
    // sessionStorage (the default) is tab-scoped: opening a link in a new tab
    // loses the session and forces re-authentication even when already logged in.
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    onSigninCallback: user => {
      // Restore the original destination encoded in the OIDC state parameter.
      // Falls back to current pathname to strip OIDC query params from the URL.
      const from = (user?.state as { from?: string } | undefined)?.from;
      globalThis.history.replaceState({}, document.title, from ?? globalThis.location.pathname);
    },
  };
}
